<template>
	<span>
		<v-breadcrumbs
			:items="breadCrumbs"
		/>
		<v-container fluid>
			<v-row>
				<v-col>
					<product-version-specification
						:product-version-id="productVersionId"
						:product-id="productId"
						:domain="domain"
					/>
				</v-col>
				<v-col
					v-if="!newVersion"
					:cols="domain === 'IE' ? '6' : '5'"
				>
					<v-row>
						<v-col>
							<v-card>
								<v-card-title>
									<translate>
										Upload PDFs
									</translate>
								</v-card-title>
								<v-card-text>
									<v-row>
										<v-col>
											<pdf-upload
												:id="productVersionId"
												file-name="Policy"
												identify-by="productversion_id"
												table-name="policyfiles"
												file-location="/downloadpolicy"
											/>
										</v-col>
										<v-col>
											<pdf-upload
												:id="productVersionId"
												file-name="IPID"
												identify-by="productversion_id"
												table-name="insuranceproductinformationdocuments"
												file-location="/downloadpolicy/ipid"
											/>
										</v-col>
										<v-col
											v-if="domain === 'IE'"
										>
											<pdf-upload
												:id="productVersionId"
												file-name="TOB"
												identify-by="productversion_id"
												table-name="termsofbusinessfiles"
												file-location="/downloadpolicy/tob"
											/>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<pricing-parameter-form
								v-can="'pricing.update'"
								:product-version-id="productVersionId"
								@update="$refs.pricingTable.update()"
							/>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<pricing-parameter-table
								ref="pricingTable"
								v-can="'pricing.read'"
								:product-version="productVersionId"
							/>
						</v-col>
					</v-row>
				</v-col>
				<v-col
					v-if="!newVersion"
					cols="4"
				>
					<coverage-edit
						:product-version-id="productVersionId"
						:languages="languages"
					/>
				</v-col>
			</v-row>
		</v-container>
	</span>
</template>
<script>
import PricingParameterForm from '../../../molecules/PricingParameterForm.vue';
import ProductVersionSpecification from '../../../molecules/ProductVersionSpecification.vue';
import PricingParameterTable from '../../../molecules/PricingParameterTable.vue';
import PdfUpload from '../../../molecules/PdfUpload.vue';
import CoverageEdit from '../../../molecules/CoverageEdit.vue';
export default {
	components: {
		CoverageEdit,
		PdfUpload,
		PricingParameterTable,
		ProductVersionSpecification,
		PricingParameterForm,
	},
	props: {
		productVersionId: {
			required: false,
			type: Number,
			default: 0
		},
		productId: {
			required: true,
			type: String,
		},
		domain: {
			required: true,
			type: String,
		},
		newVersion: {
			required: false,
			type: Boolean,
			default: false
		},
		languages: {
			required: true,
			type: Array
		},
		// eslint-disable-next-line vue/require-prop-types
		breadCrumbs: {
			required: false,
			default: []
		}
	},
};
</script>
